import styled from "styled-components";

import BodyText from "core/BodyText";
import Heading from "core/Heading";
import SectionContainer from "core/SectionContainer";
import LocationIcon from "core/ReusableIcons/Location";

import Behance from "core/ReusableIcons/Behance";
import Facebook from "core/ReusableIcons/Facebook";
import Dribbble from "core/ReusableIcons/Dribbble";
import Instagram from "core/ReusableIcons/Instagram";
import Twitter from "core/ReusableIcons/Twitter";
import Linkedin from "core/ReusableIcons/Linkedin";

import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";
import { easingSeconds } from "core/animation";
import {
    BorderBottomLinkStylesDefault,
    BorderBottomLinkStylesHover
} from "core/Typography";

export const Avatar = styled.img`
    width: ${convertPxToRem({ px: 150 })};
    height: ${convertPxToRem({ px: 150 })};
    border-radius: 50%;
    margin-bottom: ${convertPxToRem({ px: 32 })};

    @media (max-width: ${breakpoints.beforeDesktop.rem}) {
        margin-bottom: ${convertPxToRem({ px: 28 })};
    }

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        margin-bottom: ${convertPxToRem({ px: 24 })};
    }
`;

export const Name = styled(Heading).attrs({
    size: "lg",
    type: "h1",
    headingColor: colors.primary.snow
})`
    text-align: center;
`;

export const Website = styled.a`
    text-decoration: none;

    ${BodyText} {
        ${BorderBottomLinkStylesDefault}

        &:hover {
            ${BorderBottomLinkStylesHover}
        }
    }

    color: ${colors.secondary.orca};
`;

export const Description = styled(BodyText).attrs({
    size: "lg",
    type: "p",
    copyColor: colors.primary.snow
})`
    max-width: ${convertPxToRem({ px: 710 })};
    text-align: center;
    margin: 0 auto ${convertPxToRem({ px: 24 })};
`;

export const LocationText = styled(BodyText).attrs({
    size: "md",
    type: "span",
    copyColor: colors.secondary.dolphin
})``;

export const Location = styled.div`
    text-align: center;
    display: inline-flex;
    align-items: center;

    ${LocationIcon} {
        margin-right: ${convertPxToRem({ px: 8 })};
    }
`;

export const Socials = styled.div`
    margin-bottom: ${convertPxToRem({ px: 16 })};

    & > *:not(:last-child) {
        margin-right: ${convertPxToRem({ px: 20 })};
    }

    a {
        text-decoration: none;

        ${Facebook} path,
        ${Twitter} path,
        ${Behance} path,
        ${Dribbble} path,
        ${Linkedin} path,
        ${Instagram} path {
            transition: all ${easingSeconds};
        }

        &:hover {
            ${Facebook} path,
            ${Twitter} path,
            ${Behance} path,
            ${Dribbble} path,
            ${Linkedin} path,
            ${Instagram} path {
                fill: ${colors.primary.diamond};
                transition: all ${easingSeconds};
            }
        }

    }
`;

export const NameAndLocationContainer = styled.div`
    margin-bottom: ${convertPxToRem({ px: 24 })};
`;

export const SocialsContainer = styled.div`
    text-align: center;
`;

export const Container = styled(SectionContainer).attrs({
    "data-testid": "profile-header",
    topSpacing: "2xl",
    bottomSpacing: "2xl",
    textColor: colors.secondary.orca,
    bgColor: colors.secondary.cosmic
})`
    text-align: center;
`;
